import Vue from 'vue';
import VueRouter from 'vue-router';
import _ from 'lodash';
import { bus } from '../boot/global'
import routes from './routes';

Vue.use(VueRouter);

const timer = null;

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default function ({ store }) {
  const Router = new VueRouter({
    scrollBehavior: () => ({ x: 0, y: 0 }),
    routes,

    // Leave these as they are and change in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    mode: process.env.VUE_ROUTER_MODE,
    base: process.env.VUE_ROUTER_BASE,
  });

  Router.beforeResolve((to, from, next) => {
    let { token } = store.state.Menu;
    if (typeof window !== 'undefined') {
      token = token || localStorage.getItem('token')
    }
    const { userInfo } = store.state.Menu;
    const { storeUrl } = store.state.prefetch;
    if (storeUrl && to.meta.requireAuth && _.isEmpty(token)) {
      next({ path: `/${storeUrl}/login` });
    } else {
      next();
    }
  });

  Router.beforeEach((to, from, next) => {
    next();
  });

  return Router;
}
